import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { isAuthenticatedAtom, isRehydratingAtom } from '@/store/authAtoms';

export default function ProtectedRoute() {
  const isAuth = useAtomValue(isAuthenticatedAtom);
  const isRehydrating = useAtomValue(isRehydratingAtom);
  const location = useLocation();

  if (isRehydrating) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div data-testid="loading-spinner" style={{ width: 40, height: 40, borderRadius: '50%', border: '3px solid rgba(161,6,147,0.15)', borderTopColor: '#a10693', animation: 'spin 0.8s linear infinite' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return isAuth ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
}
